module.exports = __webpack_public_path__ + "static/media/38-3.cba66405.mp3";